export default __webpack_public_path__ + "static/media/users.d6e91f32.svg";